export default __webpack_public_path__ + "static/ks-logo-02e700f7e8fc54f7e0b42927fe3e30ea.png";